'use strict';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import {createGeoJsonPoint, validateCoordinates} from '../../core-utilities/geo/utils';
import {observeNewOnScope} from '../../core-utilities/rx-utils';
import {getOrganization} from '../../app/model/reducers/state';
import {AssetEditor} from '../services/AssetEditorFactory';
import template from './create-asset-directive.html';


CreateAssetController.$inject = [
  '$scope',
  '$toast',
  '$ngRedux',
  'AssetDomain',
  'MapsService',
];

export function CreateAssetDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      exposeApi: '=?'
    },
    controllerAs: 'createAsset',
    bindToController: true,
    controller: 'CreateAssetController'
  }
}

// TODO(redux-domain): refactor
export function CreateAssetController(
  $scope,
  $toast,
  $ngRedux,
  AssetDomain,
  MapsService,
) {
  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/
  const vm = this;
  resetModel();

  vm.getCoords = noop;
  vm.coordsBlur = coordsBlur;
  vm.coordsBlank = coordsBlank;
  MapsService.mapLoaded().then(_initMapApi);


  observeNewOnScope($scope, () => vm.exposeApi)
    .filter(api => isObject(api))
    .subscribe(api =>
      $scope.$evalAsync(() => {
        api.save = save;
        api.reset = resetModel;
      })
    );


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function save() {
    if (!vm.model.name && !vm.model.identifier) {
      $toast.showMessage('New assets must have a name or ID!', null, 'error');
      return Promise.reject('New assets must have a name or ID!');
    }//TODO: convert to appropriate error display

    const coords = AssetEditor.sanitizeCoordinates(vm.coords);

    if (coords) {
      if (!validateCoordinates(coords)) {
        $toast.showMessage('Latitude must be between -90 and +90. Longitude must be between -180 and 180. Otherwise leave blank.', null, 'error');
        return Promise.reject('Latitude must be between -90 and +90. Longitude must be between -180 and 180. Otherwise leave blank.');
      }//TODO: convert to appropriate error display
    }

    // View uses Lat, Long display order
    if (vm.address !== '' || coords !== null) {
      // Guard against "coords === null"
      const c = validateCoordinates(coords) ? coords : [null, null];
      vm.model.geo = createGeoJsonPoint(c[0], c[1]);

      if (vm.address !== '') {
        vm.model.geo.properties.address = vm.address;
      } else {
        vm.model.geo = omit(vm.model.geo, ['properties']);
      }
    }

    return vm.model.create()
      .then(newAsset => vm.model = newAsset)
      .catch(error => {
        console.error(error)
      });//TODO: show errors in view
  }

  function resetModel() {
    const rootState = $ngRedux.getState();
    vm.model = AssetDomain.$factory.create();

    vm.address = '';
    /** @type {Array<Number>} Latitude, Longitude */
    vm.coords = [];
    vm.model.organization = getOrganization(rootState);
  }

  function coordsBlur() {
    this.coordsMatch = isEqual(this.fetchResult ? this.fetchResult : this.initCoords, this.coords);
  }

  function coordsBlank() {
    if (!this.coords || this.coords.length === 0) return true;
    else return !this.coords[0] && !this.coords[1];
  }

  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function _initMapApi(mapApi) {
    vm.getCoords = getCoords;

    function getCoords() {
      if (vm.gettingCoords || (!vm.coordsMatch && !vm.coordsBlank())) return;
      const geocoder = new mapApi.Geocoder();
      $scope.$evalAsync(() => {
        vm.gettingCoords = true;
      });
      geocoder.geocode({address: vm.address}, (results, status) => {
        $scope.$evalAsync(() => {
          vm.gettingCoords = false;
          if (status == mapApi.GeocoderStatus.OK && results.length > 0) {
            const location = results[0].geometry.location;
            const lat = location.lat().toFixed(6);
            const lng = location.lng().toFixed(6);
            vm.coords = [lat, lng];
            vm.fetchResult = [lat, lng]; // stored for comparison
          }
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/assets/directives/CreateAssetDirective.js